import { render, staticRenderFns } from "./revie-settinges.pug?vue&type=template&id=21547824&lang=pug&"
import script from "./revie-settinges.ts?vue&type=script&lang=ts&"
export * from "./revie-settinges.ts?vue&type=script&lang=ts&"
import style0 from "./revie-settinges.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports